import "./App.css";
import { TicTacToe } from "./components/TicTacToe";

function App() {
  return (
    <div>
      <TicTacToe />
    </div>
  );
}

export default App;
